import Vue from 'vue';
import store from '@/storage/vuex'

Vue.mixin({
	computed: {
		// 当前域名
		currentDomain() {
			let currentDomain = 'localhost';
			if (process.env.NODE_ENV === 'production' && location.host.includes('.')) {
				const curentHostArr = location.host.split('.');
				const targetIndex = curentHostArr.findIndex(item => item !== 'www');
				if (targetIndex !== -1) {
					currentDomain = curentHostArr[targetIndex];
				}
			}
			return currentDomain;
		},
		// 订货2.0相关
		isForbidOrder() {
			return store.state.meetingDetail.is_forbid_order
		},
		bdhV2() {
			return ['a', 'localhost', 'zh', 'test','test3'].includes(this.currentDomain)
		}
	}
});



// WEBPACK FOOTER //
// ./src/common/systemSetting.js